import Indicator from '../Indicator';

/** Money Flow indicator */
export default class MoneyFlowIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 */
	_getDefaultParams() {
		return {
			id: 'moneyflow',
			name: 'Money Flow',
			description: 'The Money Flow Indicator measures buying and selling pressure by combining price and volume data, helping traders assess whether an asset is experiencing inflow (accumulation) or outflow (distribution) of capital.',
			componentSeries: [
				{ id: 'moneyflow' }
			]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
